export default __webpack_public_path__ + "assets/png/fb43f527b7aa33d7b993d2685b2a65d7.png";